// Employee management page and the new Add / Edit employee dialogs.
const employees = {
  title: 'Employee Management',
  subtitle: 'Search and filter employees, then act on the one you select.',
  listLabel: 'Employee list',
  actions: {
    pendingLeaves: 'Pending leave requests: {{count}}',
    missingDocs: 'Missing documents',
    missingDocsHint: 'Active employees missing a required CV/GCP/IATA document',
    download: 'Download table',
    downloadHint: 'Download table (Excel)',
    addEmployee: 'Add employee',
  },
  stats: {
    total: 'Total employees',
    totalShort: 'Total',
    active: 'Active employees',
    activeShort: 'Active',
    inactive: 'Inactive employees',
    inactiveShort: 'Inactive',
    share: 'Share of all employees: {{percent}}%',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
  },
  yes: 'Yes',
  no: 'No',
  columns: {
    eName: 'First name',
    eSurname: 'Last name',
    tcNumber: 'ID number',
    phone: 'Phone',
    eMail: 'E-mail',
    departman: 'Department',
    profession: 'Profession',
    workType: 'Work type',
    startDate: 'Start date',
    Active: 'Status',
    employeeExitDate: 'Exit date',
    address: 'Home address',
    workAddress: 'Work address',
    annualPermit: 'Annual leave',
    birthday: 'Date of birth',
    isHandicappedPerson: 'Disability',
    isIntern: 'Intern',
    isRetired: 'Retired',
    languageInfo: 'Languages',
    nationality: 'Nationality',
    educationInfo: 'Education',
  },
  options: {
    fullTime: 'Full time',
    partTime: 'Part time',
    education: {
      secondary: 'Middle / secondary school',
      highSchool: 'High school',
      associate: 'Associate degree (2-year)',
      bachelor: 'Bachelor’s degree (4-year)',
      master: 'Master’s degree',
      phd: 'Doctorate (PhD)',
    },
  },
  toolbar: {
    searchPlaceholder: 'Search by first name, last name or ID number…',
    searchPlaceholderShort: 'Search name or ID…',
    searchLabel: 'Search employees (at least 3 characters)',
    minChars: 'At least 3 characters',
    clearSearch: 'Clear search',
    statusLabel: 'Status filter',
    filters: 'Filters',
    filtersOpen: 'Filters ({{count}} on)',
    clearAll: 'Clear all',
    removeFilter: 'Remove the {{label}} filter',
    pendingFilter: 'This filter applies from 3 characters',
  },
  columnsMenu: {
    button: 'Columns',
    buttonLabel: 'Columns ({{count}}/{{total}} shown)',
    title: 'Column visibility',
    visible: '{{count}} / {{total}} shown',
    showAll: 'Show all',
    reset: 'Reset to default',
    resetHint: 'Default columns and widths',
    lastColumn: 'At least one column must stay visible',
    hiddenWhenActive: 'Hidden for Active',
    hiddenWhenActiveHint: 'This column is hidden while the status filter is “Active”',
  },
  filter: {
    title: '{{label}} filter',
    titleOn: '{{label}} filter (on)',
    placeholder: 'Search…',
    clear: 'Clear',
    minChars: 'Type at least 3 characters',
    all: 'All',
  },
  table: {
    label: 'Employees',
    resizeLabel: 'Width of the {{label}} column',
    resizeHint: 'Drag to change the width, double-click to reset',
    scrollLeft: 'Scroll the table left',
    scrollRight: 'Scroll the table right',
    empty: 'No employees match the filters',
    noColumns: 'No visible columns',
    showDefaultColumns: 'Show default columns',
    clearFilters: 'Clear filters',
    pendingLeave: 'Pending leave requests: {{count}}',
    pendingLeaveSr: 'pending leave requests',
    primaryAddress: 'Primary',
    loading: 'Loading employees',
  },
  pagination: {
    rangeOf: 'of {{total}} employees',
    ofTotal: 'out of {{total}} in total',
    noResults: 'No results',
    loading: 'Loading…',
    pages: 'Pages',
    first: 'First page',
    previous: 'Previous page',
    next: 'Next page',
    last: 'Last page',
    page: 'Page {{page}}',
  },
  panel: {
    label: 'Selected employee',
    heading: 'Employee',
    previous: 'Previous employee',
    next: 'Next employee',
    close: 'Close (Esc)',
    actions: 'Actions',
    details: 'Details',
    card: 'Employee card',
    edit: 'Edit',
    files: 'Files',
    projects: 'Projects',
    accountCreate: 'Create account',
    accountCreateHint: 'Create a user account for this employee',
    accountChecking: 'Checking…',
    accountCheckingHint: 'Checking the user account…',
    accountExists: 'Has account',
    accountExistsHint: 'This employee already has a user account',
    deactivate: 'Make inactive',
    activate: 'Make active',
    statusHint: 'Change status',
    pendingLeaves: '{{count}} pending leave requests',
    copy: 'Copy',
    copyLabel: 'Copy {{label}}',
    copied: '{{label}} copied',
    copyFailed: 'Couldn’t copy to the clipboard',
    primaryAddress: 'Primary address · {{label}}',
  },
  filterSheet: {
    subtitle: 'Narrow the list down by column',
    show: 'Show {{count}} results',
  },
  toast: {
    loadError: 'Employees couldn’t be loaded',
    activated: 'The employee is active again, and so are their project assignments',
    statusError: 'The status couldn’t be updated',
    userCheckError: 'The user account couldn’t be checked.',
    leaveDeleted: 'Leave request deleted',
    leaveDeleteError: 'The leave request couldn’t be deleted',
    excelPreparing: 'Preparing the Excel file…',
    excelSuccess: 'Excel file downloaded',
    excelError: 'The Excel file couldn’t be downloaded',
  },
  form: {
    addTitle: 'Add employee',
    addSubtitle: 'Fields marked * are required',
    editTitle: 'Edit employee',
    sections: 'Form sections',
    stepOf: '{{current}} / {{total}}',
    personal: 'Personal details',
    personalHint: 'Identity and basic details',
    contact: 'Contact',
    contactHint: 'E-mail, phone numbers and addresses',
    employment: 'Employment',
    employmentHint: 'Department, role, permissions and work pattern',
    education: 'Education & languages',
    educationHint: 'Education level and foreign languages',
    fields: {
      ID: 'Employee number',
      eName: 'First name',
      eSurname: 'Last name',
      tcNumber: 'National ID number',
      nationality: 'Nationality',
      birthday: 'Date of birth',
      eMail: 'E-mail',
      phone: 'Phone',
      emergencyPhone: 'Emergency phone',
      address: 'Home address',
      workAddress: 'Work address',
      departman: 'Department',
      profession: 'Profession',
      role: 'Employee role',
      authorization: 'Permission',
      workType: 'Work type',
      Active: 'Status',
      startDate: 'Start date',
      annualPermit: 'Annual leave (days)',
      educationInfo: 'Education',
      languageInfo: 'Languages',
      isHandicappedPerson: 'Disabled',
      isRetired: 'Retired',
      isIntern: 'Intern',
    },
    choose: 'Select',
    outOfList: '{{value}} (not in list)',
    loadingDepartments: 'Loading departments…',
    loadingRoles: 'Loading roles…',
    authorizationLocked: 'Only the super admin can change this field',
    roleNotInList: 'This role isn’t in the list; trainings and SOPs won’t be assigned by it.',
    phonePlaceholder: '5XX XXX XX XX',
    emergencyPlaceholder: '5XX XXX XX XX (optional)',
    phoneExample: 'e.g. 532 123 45 67',
    emergencyExample: 'Phone for emergencies (optional)',
    flags: 'Statuses',
    email: {
      placeholder: 'name.surname',
      hint: 'Type only the start of the address; the domain is added for you.',
      preview: 'Will be saved as: {{email}}',
      invalid: 'Use only English letters, digits and . _ - +',
      external: 'Non-company address',
      externalHint: 'This address is kept as it is.',
      convert: 'Switch to @{{domain}}',
    },
    languages: {
      language: 'Language',
      level: 'Level',
      chooseLanguage: 'Select a language',
      chooseLevel: 'Level',
      native: 'Native',
      add: 'Add language',
      remove: 'Remove this language',
      empty: 'No languages added yet.',
    },
    required: 'This field is required',
    phoneInvalid: 'The phone number needs 10 digits (5XX XXX XX XX)',
    fixErrors: 'Please correct the highlighted fields.',
    back: 'Back',
    nextSection: 'Next',
    cancel: 'Cancel',
    saveNew: 'Save employee',
    save: 'Save',
    saving: 'Saving…',
    unsaved: 'You have unsaved changes.',
    keepEditing: 'Keep editing',
    discard: 'Close without saving',
    duplicateEmail: 'An employee with this e-mail address already exists!',
    added: 'Employee added!',
    addError: 'The employee couldn’t be added!',
    updated: 'Employee details updated',
    updateError: 'The employee couldn’t be updated: {{message}}',
    departmentsError: 'Departments couldn’t be loaded.',
    rolesError: 'Permission roles couldn’t be loaded.',
  },
  // Other dialogs opened from employee management
  modals: {
    card: {
      title: 'Employee card',
      personal: 'Personal details',
      contact: 'Contact',
      work: 'Employment',
      addresses: 'Addresses',
      age: '{{age}} years old',
      photoAlt: 'Photo of {{name}}',
      edit: 'Edit',
    },
    files: {
      title: 'Files',
      category: 'File type',
      chooseCategory: 'Choose the file type first',
      alreadyUploaded: 'A file of this type already exists; delete it before uploading a new one.',
      uploadedMark: '{{label}} · uploaded',
      drop: 'Drag files here',
      or: 'or',
      browse: 'Choose files',
      uploading: 'Uploading…',
      accepted: 'PDF, Word, Excel and images',
      uploadedTab: 'Uploaded files',
      cvTab: 'CV / GCP / IATA',
      uncategorized: 'Uncategorised',
      none: 'This employee has no files yet.',
      cvNone: 'This employee has no CV/GCP/IATA documents.',
      cvHint: 'Employees upload these documents from their own profile.',
      open: 'Open file',
      view: 'View',
      download: 'Download file',
      delete: 'Delete file',
      confirmDelete: 'Delete it?',
      confirm: 'Delete',
      cancel: 'Cancel',
      loading: 'Loading…',
      exitReason: 'An exit contract was uploaded for {{name}}. Enter the leaving date to complete the exit.',
      toast: {
        chooseCategory: 'Please choose the file type!',
        duplicate: 'A file of this type ({{category}}) is already uploaded! Delete the existing file first.',
        uploaded: 'Files uploaded!',
        uploadError: 'The upload failed!',
        deleted: 'File deleted!',
        deleteError: 'The file could not be deleted!',
      },
    },
    exit: {
      title: 'Leaving date',
      label: 'Leaving date of {{name}}',
      effect: 'Saving makes the employee inactive, removes their portal access and sets all their project assignments to inactive.',
      required: 'Please choose the leaving date',
      saved: 'The employee is now inactive, the leaving date is saved and all their project assignments are inactive',
      error: 'The status could not be updated',
    },
    account: {
      title: 'Create user account',
      subtitle: 'Portal account for the employee',
      noEmail: 'This employee has no e-mail address. Accounts are opened by e-mail, so add one under Edit first.',
      password: 'Password',
      confirmPassword: 'Confirm password',
      generate: 'Generate',
      generateHint: 'Generate a strong password',
      copy: 'Copy password',
      copied: 'Password copied',
      copyFailed: 'The password could not be copied',
      match: 'Passwords match',
      noMatch: 'Passwords do not match',
      role: 'Role',
      roles: {
        employee: 'Employee',
        admin: 'Administrator',
        finance: 'Finance manager',
        project: 'Project manager',
        fieldCoordinator: 'Field coordinator',
        hr: 'Human resources',
        smoLead: 'SMO Lead',
      },
      mailNote: 'The login details are sent to the employee’s e-mail address.',
      submit: 'Create user',
      creating: 'Creating…',
      errors: {
        mismatch: 'The passwords do not match or are empty.',
        short: 'The password needs at least 6 characters.',
        emailInUse: 'This e-mail address is already used by another user.',
        invalidEmail: 'Invalid e-mail format.',
        weak: 'The password is not strong enough.',
        generic: 'The user could not be created: {{message}}',
      },
      toast: {
        createdAndMailed: 'User created and the login details e-mailed.',
        mailFailed: 'User created, but the e-mail could not be sent. Please pass on the details yourself.',
        created: 'User {{email}} created. You are still signed in as admin.',
        emailInUse: 'E-mail already in use.',
        invalidEmail: 'Invalid e-mail.',
        weak: 'Weak password.',
        generic: 'Could not create the user.',
      },
    },
    missingDocs: {
      title: 'Employees with missing documents',
      subtitle: '{{count}} active employees',
      hint: 'Active employees are checked for the required CV/GCP/IATA documents. Employees upload them from their own profile.',
      search: 'Search employees…',
      loadError: 'Missing documents could not be loaded.',
      noMatch: 'No employees match the search.',
      none: 'No employee is missing documents.',
      openFiles: 'Files',
      openFilesHint: 'Open the employee’s files',
    },
    pendingLeaves: {
      title: 'Pending leave requests',
      subtitle: '{{count}} requests awaiting approval',
      none: 'There are no pending leave requests.',
      unknownEmployee: 'Unknown employee',
      days_one: '{{count}} day',
      days_other: '{{count}} days',
      focus: 'Go to employee',
      focusHint: 'Click to jump to the employee',
      delete: 'Delete',
      deleteHint: 'Delete the leave request',
      confirmDelete: 'Delete it?',
      cancel: 'Cancel',
      types: {
        yillik: 'Annual leave',
        mazeret: 'Excused leave',
        raporlu: 'Sick leave',
      },
    },
  },
  fileCategories: {
    idCopy: 'ID card copy',
    residence: 'Proof of residence',
    criminalRecord: 'Criminal record',
    healthReport: 'Health report',
    registry: 'Civil registry record',
    familyStatus: 'Family status declaration',
    highSchool: 'High school diploma',
    bachelor: 'Bachelor’s diploma',
    master: 'Master’s diploma',
    phd: 'Doctorate diploma',
    sgk: 'SGK registration',
    employmentContract: 'Employment contract',
    exitContract: 'Exit contract',
    bloodCard: 'Blood card',
    photo: 'Photo',
    certificate: 'Certificate',
    associate: 'Associate diploma',
    other: 'Other',
  },
  cvTypes: {
    cvTr: 'Turkish CV',
    cvEn: 'English CV',
    gcp: 'GCP',
    iata: 'IATA',
  },
  nationalities: {
    turkish: 'Turkish',
    afghan: 'Afghan',
    german: 'German',
    american: 'American',
    arab: 'Arab',
    albanian: 'Albanian',
    azerbaijani: 'Azerbaijani',
    belgian: 'Belgian',
    bosnian: 'Bosnian',
    bulgarian: 'Bulgarian',
    chinese: 'Chinese',
    french: 'French',
    georgian: 'Georgian',
    indian: 'Indian',
    dutch: 'Dutch',
    british: 'British',
    iranian: 'Iranian',
    spanish: 'Spanish',
    swedish: 'Swedish',
    italian: 'Italian',
    japanese: 'Japanese',
    kazakh: 'Kazakh',
    kyrgyz: 'Kyrgyz',
    korean: 'Korean',
    lebanese: 'Lebanese',
    macedonian: 'Macedonian',
    egyptian: 'Egyptian',
    moldovan: 'Moldovan',
    uzbek: 'Uzbek',
    pakistani: 'Pakistani',
    polish: 'Polish',
    portuguese: 'Portuguese',
    romanian: 'Romanian',
    russian: 'Russian',
    serbian: 'Serbian',
    syrian: 'Syrian',
    tajik: 'Tajik',
    tunisian: 'Tunisian',
    turkmen: 'Turkmen',
    ukrainian: 'Ukrainian',
    jordanian: 'Jordanian',
    greek: 'Greek',
    other: 'Other',
  },
  languageNames: {
    english: 'English',
    german: 'German',
    french: 'French',
    spanish: 'Spanish',
    italian: 'Italian',
    russian: 'Russian',
    arabic: 'Arabic',
    persian: 'Persian',
    chinese: 'Chinese',
    japanese: 'Japanese',
    korean: 'Korean',
    portuguese: 'Portuguese',
    dutch: 'Dutch',
    greek: 'Greek',
    azerbaijani: 'Azerbaijani',
    turkish: 'Turkish',
    other: 'Other',
  },
};

export default employees;
